import {
    InteractionEntity,
    NoteEntity,
    ObservationEntity,
} from '../../coaching-base/config';
import { EventResult, FocusContainerDto } from '../../coaching-base/general';
import { EventParticipantDto } from '../../coaching-base/general/event-participant-observation-dto.model';
import { BehaviourItem } from '../../coaching-tags/models/behaviour.coaching.model';
import { MetricItem } from '../../coaching-tags/models/metric.coaching.model';
import { QueueItem } from '../../coaching-tags/models/queue.coaching.model';
import { SubBehaviourItem } from '../../coaching-tags/models/subbehaviour.coaching.model';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ObservationCommitDialogItem } from '../observation-commit-dialog/observation-commit-dialog.component';

import { DraftIdByIdentifier } from './observation-focus-draft-id-identifier.model';
import { ObservationFormValue } from './observation-form-value.model';
import {
    AllowedActions,
    EnabledActions,
    NavigationScenario,
    NavigationScenarioOptions,
    ObservationMode,
} from './observation.model';

export interface RootState {
    pending: {
        reload?: boolean;
        save?: boolean;
        notification?: boolean;
        delete?: boolean;
    };
    justSaved?: boolean; // TODO something more elaborate

    // lookups
    behaviours?: BehaviourItem[];
    subBehaviours?: SubBehaviourItem[];
    metrics?: MetricItem[];
    queues?: QueueItem[];

    // config and form defaults
    coachingEvent?: ObservationEntity;
    noteEntity?: NoteEntity;
    interactionEntity?: InteractionEntity;
    defaultInteractionTypeId?: number;

    // main
    mode?: ObservationMode;
    event?: EventResult;
    performer?: EventParticipantDto;
    observer?: EventParticipantDto;
    focusContainers?: FocusContainerDto[];
    initialFormValue?: ObservationFormValue;

    //
    willNavigate?: boolean;
    navigationScenario?: NavigationScenario;
    navigationScenarioOpts?: NavigationScenarioOptions;
    allowedActions?: AllowedActions;
    enabledActions?: EnabledActions;

    // TODO revise. see usages of state.dialogItems
    nextCommitmentDraftId?: string;
    draftIdByIdentifier?: DraftIdByIdentifier;
    nextCommitmentId?: number;
}

export const defaultState = (): RootState => ({
    pending: {},
});
